<template>
    <div class="page">
<!-- ../../assets/news-top.png -->
        <img :src="require('@/assets/'+bg)" alt="">
        <div class="wrap d_f jc_sb ai_c">
            <h2 class="d_f d_f_c jc_c ai_c">
                <p class="P_ml">
                    {{pagename}}
                </p>
                <span class="P_s">
                    {{desc}}
                </span>
            </h2>

            <p class="mb">
                {{mb}}
            </p>

        </div>
    </div>
</template>

<script>
export default {
    
    props : {
        bg : String,
        pagename : String,
        desc : String,
        mb : String,
    },



}
</script>

<style lang="scss" scoped>

    .page{
        position: relative;
        width: 100%;
        height: 323px;
        overflow: hidden;
        img{
            width: 100%;
            height: 260px;
        }
        .wrap{
            position: relative;
            width: 1200px;
            margin: auto;
            height: 63px;
            h2{
                position: absolute;
                top: -126px;
                transform: translateY(50%);
                width: 330px;
                height: 126px;
                color: #fff;
                background-color: #0067CC;
                p,span{
                    margin: 0;
                }
            }
            .mb{
                position: absolute;
                right: 0;
            }
        }
    }

</style>